export default {
  namespaced: true,
  state: 
  {
    usuario: JSON.parse(localStorage.getItem('usuario') || null),
    cliente: JSON.parse(localStorage.getItem('cliente') || null),
    empresas: [],
    responseLogin: [],
    imagenLogo: '',
    imagenHeader: '',
    ctaCte:'',
    email:''
  },

  mutations: 
  {
    saveUsuario (state, user) 
    {
      state.usuario = user
      localStorage.setItem("usuario",JSON.stringify(user));
    },

    saveCliente (state, cliente) 
    {
      state.cliente = cliente
      localStorage.setItem("cliente",JSON.stringify(cliente));
    },

    saveEmpresas (state, empresas) 
    {
      state.empresas = empresas
    },

    saveResponseLogin (state, responseLogin) 
    {
      state.responseLogin = responseLogin
    },

    saveImagenLogo (state, imagenLogo) 
    {
      state.imagenLogo = imagenLogo
    },

    saveImagenHeader (state, imagenHeader) 
    {
      state.imagenHeader = imagenHeader
    },

    saveCtaCte (state, ctacte) 
    {
      state.ctaCte = ctacte
    },

    saveEmail (state, e) 
    {
      state.email = e
    },


    deleteUser (state) 
    {
      state.usuario = null
      localStorage.removeItem("usuario");
    },

    deleteCliente (state) 
    {
      state.cliente = null
      localStorage.removeItem("cliente");
    },
    
    deleteEmpresas (state) 
    {
      state.empresas = []
    },

    deleteResponseLogin (state) 
    {
      state.responseLogin = []
    },

    deleteImagenLogo (state) 
    {
      state.imagenLogo = ''
    },

    deleteImagenHeader (state) 
    {
      state.imagenHeader = ''
    },

    deleteCtaCte (state) 
    {
      state.ctaCte = ''
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js